import { render, staticRenderFns } from "./ControlPreview.vue?vue&type=template&id=5fc0fe27&scoped=true&"
import script from "./ControlPreview.vue?vue&type=script&lang=js&"
export * from "./ControlPreview.vue?vue&type=script&lang=js&"
import style0 from "./ControlPreview.vue?vue&type=style&index=0&id=5fc0fe27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0fe27",
  null
  
)

export default component.exports